(function() {
	'use strict';

	angular
		.module('pwc.agingPotential')
		.factory('AgingPotential', AgingPotential);

	AgingPotential.$inject = ['$q', 'lodash', 'PWCData', '$log'];

	function AgingPotential($q, lodash, PWCData, $log) {

		var wine = {};

		// aging potential ratings
		var aptData = [];

		var countryData = [];

		// vintage ratings
		var vrtData = [];

		var ap;

		var vr;

		var AP_QUERY = {};

		// convert the rating (from VintageRatings) into what's used for the calculations.
		function getRatingPercentage(rating) {

			var vrp;

			switch(parseInt(rating))
			{
				case 7:
					vrp = 1;
					break;
				case 6:
					vrp = 0.857;
					break;
				case 5:
					vrp = 0.714;
					break;
				case 4:
					vrp = 0.571;
					break;
				case 3:
					vrp = 0.429;
					break;
				case 2:
					vrp = 0.286;
					break;
				case 1:
					vrp = 0.143;
					break;
				// what do we do for default?
				// maybe just show an error
				// I was unable to find a wine with rating of 0 in the demo copy I have.
				// I need a way to export zk_IDdistinction & zk_IDregion so I can recreate this case
				default:
					// @TODO handle this case
					vrp = 0;
					break;
			}

			return vrp;
		}

		function getVintageRatingDescription(rating){
			switch(rating){
				case 7:
					return 'an outstanding vintage';

				case 6:
					return 'an excellent vintage';

				case 5:
					return 'a very good vintage';

				case 4:
					return 'a good vintage';

				case 3:
					return 'an average vintage';

				case 2:
					return 'a below average vintage';

				case 1:
					return 'a poor vintage';

				default:
					return 'a non-declared vintage';
			}
		}

		function _getAPBySubRegion(id){

			// try to find by subregion id

			var where = angular.extend(angular.copy(AP_QUERY), {
				'ids': id
			});

			var result = lodash.findWhere(aptData, where);

			$log.debug("Trying to find AP Record by subregion (ids)", id, where, result);

			return result;
		}

		function _getAPByRegion(id){

			// try to find by region id

			var where = angular.extend(angular.copy(AP_QUERY), {
				'idr': id
			});

			var result = lodash.findWhere(aptData, where);

			$log.debug("Trying to find AP Record by region (idr)", id, where, result);

			return result;
		}

		function _getAPByCountry(){

			// try to find by country id

			var result = null;

			var where = null;

			var countryName = lodash.get(wine, 'region.country');

			var country = lodash.findWhere(countryData, {
				"n": countryName
			});

			var countryId = lodash.get(country, 'id');

			if (lodash.isNotEmptyOrNull(country))
			{
				where = angular.extend(angular.copy(AP_QUERY), {
					'idc': countryId
				});

				result = lodash.findWhere(aptData, where);
			}

			$log.debug("Trying to find AP Record by country (idc)", countryId, where, result);

			return result;
		}

		function getAPRecord(){

			var result = null;

			var distinctionId = lodash.get(wine, 'distinction.legacyId');

			var subRegion = lodash.get(wine, 'region');

			var subRegionId = lodash.get(subRegion, 'legacyId');

			var regionId = lodash.get(wine, 'region.parent.legacyId');

			$log.debug("Looking for Aging Potential Record...");
			$log.debug("distinction id (idd)", distinctionId);
			$log.debug("subregion id (ids)", subRegionId);
			$log.debug("region id (idr)", regionId);

			result = _getAPBySubRegion(subRegionId);

			if (lodash.isNotEmptyOrNull(result)){ return result; }

			if (regionId){

				result = _getAPByRegion(regionId);

				if (lodash.isNotEmptyOrNull(result)){ return result; }
			}

			result = _getAPByRegion(subRegionId);

			if (lodash.isNotEmptyOrNull(result)){ return result; }

			result = _getAPByCountry();

			return result;
		}

		function getVintageRating(category){

			$log.debug('Getting Vintage Rating for ', category);

			return lodash.findWhere(vrtData, {
				"c": category,
				"v": parseInt(wine.vintage)
			});
		}

		function getWineQualityPercentage(){

			var userRating = wine.cellar.aging.quality;

			var pct;

			switch(userRating){
				case 'Outstanding':
					pct = 1;
				break;

				case 'Excellent':
					pct = 0.8;
				break;

				case 'Very Good':
					pct = 0.6;
				break;

				case 'Good':
					pct = 0.4;
				break;

				case 'Average':
					pct = 0.2;
				break;

				default:
					pct = 0;
				break;
			}

			return pct;
		}

		function calculate(){
			/* jshint validthis: true */
			var self = this;

			$log.debug('Calculating Aging Potential...', ap, vr);

			if (lodash.isNotEmptyOrNull(ap) && lodash.isNotEmptyOrNull(vr)){

				var realAP = (ap['ap'] * getRatingPercentage(vr['r']) + ap['ap'] * getWineQualityPercentage()) / 2;

				self.after = lodash.add(parseInt(wine.vintage), ap['a']);

				// round this the the closest(?) whole number.
				self.by = Math.round(lodash.add(parseInt(wine.vintage), realAP));

				if (self.by < self.after) {
					self.by = self.after;
				}

				return true;
			}

			return false;
		}

		function _initializeAPQuery(){

			var distinctionId = lodash.get(wine, 'distinction.legacyId');

			var where = {};

			if (distinctionId){

				where.idd = distinctionId;

			} else {

				where.d = lodash.get(wine, 'distinction.name');
			}

			AP_QUERY = where;
		}

		return function(Wine) {

			var deferred = $q.defer();

			var promises = [];

			wine = Wine;

			_initializeAPQuery();

			promises.push(PWCData.fetch('agingPotential').then(function(data){
				aptData = data;
			}));

			promises.push(PWCData.fetch('vintageRatings').then(function(data){
				vrtData = data;
			}));

			promises.push(PWCData.fetch('countries').then(function(data){
				countryData = data;
			}));

			$q.all(promises).then(function(){

				// data is setup, time to do some work
				ap = getAPRecord();

				if (lodash.isNotEmptyOrNull(ap) && lodash.isNotEmptyOrNull(ap.c)){
					vr = getVintageRating(ap.c);
				}

				var agingPotential = {
					"after": null,
					"by": null,
					"place": lodash.isNotEmptyOrNull(ap) ? ap.p : null,
					"max": lodash.isNotEmptyOrNull(ap) ? ap.ap : null,
					"quality": lodash.get(Wine, 'cellar.aging.quality', null),
					"vintageDescription": lodash.isNotEmptyOrNull(vr) ? getVintageRatingDescription(vr['r']) : null,
					"calculate": calculate
				};

				agingPotential.calculate();

				$log.debug('Aging Potential', agingPotential);

				deferred.resolve(agingPotential);

			});

			return deferred.promise;
		};

	}

})();
